import http from '../http'

export default {
  // 获取家族等级介绍
  getFamilyLvInfo(data: object) {
    return http.post('/web/family/GetFamilyLvInfo', data);
  },
  // 设置家族管理员
  familySetAdmin(data: object) {
    return http.post('/web/family/FamilySetAdmin', data);
  },
  // 获取家族成员列表
  getFamilyMembersList(data: object) {
    return http.post('/web/family/GetFamilyMembersList', data);
  },
  // 获取家族级别信息
  getFamilyTierIntroInfo(data: object) {
    return http.post('/web/family/tier/intro', data);
  },
}
